<template>
  <Select
    :items="regimes"
    :selectedItem="filter.regime"
    label="Regime"
    searchPlaceholder="Buscar regime"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
    :fixo="filtro?.fixo"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        regime: {
          id: "",
          name: "",
        },
      },
      regimes: [
        { id: "caixa", name: "Caixa" },
        { id: "competência", name: "Competência" },
      ],
    };
  },
  methods: {
    atualizar(regime) {
      const regimeSelecionado = regime.id ? regime : this.regimePadrao;
      this.filter.regime = { ...regimeSelecionado };

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.regime.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.regime.id
      });
    },
    sincronizarRegimeComFiltro() {
      const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];

      if (!filtroAplicado) {
        this.filter.regime = { ...this.regimePadrao };
        return;
      }

      this.$renderFiltroSelect(filtroAplicado, this.regimes, this.filter.regime);

      if (!this.filter.regime.id) {
        this.filter.regime = { ...this.regimePadrao };
      }
    },
  },
  computed: {
    regimePadrao() {
      return this.regimes[0];
    },
  },
  watch: {
    '$store.state.filtroAplicados': {
      handler() {
        this.sincronizarRegimeComFiltro();
      },
      deep: true
    }
  },
  mounted() {
    this.sincronizarRegimeComFiltro();
  },
}
</script>
